import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  es: {
    translation: {
      app: {
        name: 'CleanHands',
        tagline: 'Observador de Higiene de Manos',
      },
      common: {
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        save: 'Guardar',
        delete: 'Eliminar',
        back: 'Volver',
        next: 'Siguiente',
        finish: 'Finalizar',
        yes: 'Sí',
        no: 'No',
        loading: 'Cargando...',
        error: 'Error',
        success: 'Éxito',
        goHome: 'Ir al Inicio',
        offline: 'Sin Conexión',
        active: 'Activo',
      },
      nav: {
        home: 'Inicio',
        sessions: 'Sesiones',
        settings: 'Configuración',
      },
      appBar: {
        home: 'CleanHands',
        newSession: 'Nueva Sesión',
        observation: 'Observación',
        sessionSummary: 'Resumen de Sesión',
        activeSessions: 'Sesiones Activas',
        settings: 'Configuración',
      },
      sideNav: {
        title: 'CleanHands',
        subtitle: 'Observador de Higiene de Manos',
      },
      home: {
        title: 'Sesiones de Observación',
        subtitle: 'Ver y administrar sus sesiones de observación de higiene de manos',
        loadingSessions: 'Cargando sesiones...',
        newSession: 'nueva sesión',
        printDate: 'Fecha de impresión',
        printFilterSummary: 'Mostrando {{count}} sesión(es) filtrada(s)',
      },
      sessionSetup: {
        title: 'Nueva Sesión de Observación',
        subtitle: 'Ingrese los detalles de su sesión de observación de higiene de manos',
        facilityName: 'Nombre del Centro de Salud',
        facilityPlaceholder: 'ej., Hospital General de la Ciudad',
        serviceName: 'Nombre del Servicio',
        servicePlaceholder: 'ej., Cirugía, Pediatría',
        serviceType: 'Tipo de Servicio',
        serviceTypePlaceholder: 'ej., UCI, Emergencias, Ambulatorio',
        wardName: 'Nombre de la Sala',
        wardPlaceholder: 'ej., Sala 3A, UCI-2',
        periodNumber: 'Número de Período',
        periodType: 'Tipo de Período',
        observerInitials: 'Iniciales del Observador',
        observerPlaceholder: 'ej., AB, JD',
        startSession: 'Iniciar Sesión',
        failedCreate: 'Error al crear la sesión',
        validation: {
          facilityRequired: 'Nombre del centro requerido (mín. 2 caracteres)',
          serviceRequired: 'Nombre del servicio requerido (mín. 2 caracteres)',
          serviceTypeRequired: 'Tipo de servicio requerido',
          wardRequired: 'Nombre de la sala requerido (mín. 2 caracteres)',
          periodMin: 'El número de período debe ser al menos 1',
          observerRequired: 'Iniciales del observador requeridas (2-4 caracteres)',
          observerMax: 'Las iniciales deben ser de 2-4 caracteres',
        },
      },
      periodTypes: {
        baseline: 'Línea de Base',
        post_intervention: 'Post-Intervención',
        follow_up_1: 'Seguimiento 1',
        follow_up_2: 'Seguimiento 2',
        annual: 'Anual',
      },
      observation: {
        sessionProgress: 'Progreso de la Sesión',
        complianceRate: 'Tasa de Cumplimiento',
        totalOpportunities: 'Total de Oportunidades',
        actionsPerformed: 'Acciones Realizadas',
        missed: 'Omitidas',
        recordedOpportunities: 'Oportunidades Registradas',
        loadingSession: 'Cargando sesión...',
        sessionNotFound: 'Sesión no encontrada',
        opportunityRecorded: 'Oportunidad registrada exitosamente',
        opportunityDeleted: 'Oportunidad eliminada',
        failedSave: 'Error al guardar oportunidad',
        failedDelete: 'Error al eliminar oportunidad',
      },
      hcwSelector: {
        title: 'Seleccionar Trabajador de Salud',
        subtitle: 'Toque una estrella de color para seleccionar la categoría y asignar un trabajador',
        searchPlaceholder: 'Buscar categorías...',
      },
      indications: {
        title: 'Seleccionar Indicación(es)',
        subtitle: 'Seleccione al menos uno de los 5 momentos',
        nextAction: 'Siguiente: Seleccionar Acción',
        backToHCW: 'Volver a Trabajador de Salud',
        before_patient: {
          label: 'Antes de Tocar al Paciente',
          shortLabel: 'Antes del Paciente',
          description: 'Antes de tocar al paciente',
        },
        before_aseptic: {
          label: 'Antes de Procedimiento Aséptico',
          shortLabel: 'Antes de Aséptico',
          description: 'Antes de un procedimiento limpio/aséptico',
        },
        after_body_fluid: {
          label: 'Después de Exposición a Fluidos Corporales',
          shortLabel: 'Después de Fluidos',
          description: 'Después de riesgo de exposición a fluidos corporales',
        },
        after_patient: {
          label: 'Después de Tocar al Paciente',
          shortLabel: 'Después del Paciente',
          description: 'Después de tocar al paciente',
        },
        after_surroundings: {
          label: 'Después de Tocar el Entorno del Paciente',
          shortLabel: 'Después del Entorno',
          description: 'Después de tocar el entorno del paciente',
        },
      },
      actions: {
        title: 'Seleccionar Acción Realizada',
        subtitle: '¿Qué acción de higiene de manos se realizó?',
        handrub: 'Fricción',
        handwash: 'Lavado',
        both: 'Ambos (Fricción y Lavado)',
        bothShort: 'Ambos',
        missed: 'Omitido',
        backToIndications: 'Volver a Indicaciones',
        glovesTitle: '¿Se Usaron Guantes?',
        glovesSubtitle: 'Ya que se omitió la higiene de manos, ¿se usaron guantes?',
      },
      recorder: {
        step1: 'Trabajador de Salud',
        step2: 'Indicaciones',
        step3: 'Acción',
      },
      opportunityList: {
        noOpportunities: 'Aún no se han registrado oportunidades',
        tapToRecord: 'Toque el botón + para registrar su primera oportunidad',
        gloves: 'Guantes',
      },
      sessionTimer: {
        duration: 'Duración de la Sesión',
        longSession: 'Sesión Larga',
        lessThan10: '< 10 min',
      },
      sessionList: {
        noSessions: 'Aún no hay sesiones',
        createNew: 'Cree una nueva sesión para comenzar',
        completed: 'Completada',
        paused: 'Pausada',
        inProgress: 'En Progreso',
        session: 'Sesión',
      },
      floatingActions: {
        activeSession: 'Sesión Activa',
        newOpportunity: 'Nueva Oportunidad',
        sessionSummary: 'Resumen de Sesión',
        endSession: 'Finalizar Sesión',
        sessionActions: 'Acciones de sesión',
      },
      exitDialog: {
        title: 'Sesión en Progreso',
        message: 'Tiene una sesión de observación activa. ¿Desea guardar sus datos y finalizar la sesión, o continuar registrando?',
        continueRecording: 'Continuar Registrando',
        saveAndEnd: 'Guardar y Finalizar Sesión',
      },
      sessionSummary: {
        title: 'Resumen de Sesión',
        facility: 'Centro de Salud',
        ward: 'Sala',
        service: 'Servicio',
        observer: 'Observador',
        date: 'Fecha',
        duration: 'Duración',
        na: 'N/D',
        overallCompliance: 'Cumplimiento General',
        ofOpportunities: '{{performed}} de {{total}} oportunidades',
        performed: 'Realizadas',
        missedLabel: 'Omitidas',
        glovesWorn: 'Guantes Usados',
        methodBreakdown: 'Desglose por Método',
        handrub: 'Fricción',
        handwash: 'Lavado',
        both: 'Ambos',
        observationsByCategory: 'Observaciones por Categoría',
        categoryHeader: 'Categoría',
        hwsHeader: 'TSs',
        oppsHeader: 'Opps',
        complianceHeader: 'Cumplimiento',
        complianceByIndication: 'Cumplimiento por Indicación (5 Momentos)',
        momentHeader: 'Momento',
        countHeader: 'Cantidad',
      },
      sessionReview: {
        recordedOpportunities: 'Oportunidades Registradas',
        continueRecording: 'Continuar Registrando',
        sessionNotes: 'Notas de la Sesión',
        notesPlaceholder: 'Agregue notas u observaciones sobre esta sesión...',
        saveNotes: 'Guardar Notas',
        exportData: 'Exportar Datos',
        downloadCSV: 'Descargar CSV',
        allOpportunities: 'Todas las Oportunidades',
        returnHome: 'Volver al Inicio',
        notesSaved: 'Notas guardadas exitosamente',
        failedSaveNotes: 'Error al guardar notas',
        csvDownloaded: 'Archivo CSV descargado exitosamente',
        failedExport: 'Error al exportar CSV',
      },
      activeSessions: {
        title: 'Sesiones Activas',
        subtitle: 'Seleccione una sesión para continuar registrando',
        loadingSessions: 'Cargando sesiones...',
      },
      settings: {
        title: 'Configuración',
        subtitle: 'Configure los ajustes de su aplicación',
        language: 'Idioma',
        languageDescription: 'Seleccione su idioma preferido',
        spanish: 'Español',
        english: 'English',
        dataManagement: 'Gestión de Datos',
        clearDataDescription: 'Eliminar todos los datos locales incluyendo sesiones, oportunidades y configuración. Esta acción no se puede deshacer.',
        clearAllData: 'Eliminar Todos los Datos',
        clearConfirm: '¿Está seguro de que desea eliminar todos los datos locales? Esta acción no se puede deshacer.',
        clearSuccess: 'Todos los datos eliminados exitosamente',
        clearError: 'Error al eliminar datos',
        appInfo: 'Información de la Aplicación',
        appVersionAndUpdates: 'Versión y Actualizaciones',
        version: 'Versión',
        updateAvailable: 'Actualización Disponible',
        updateNow: 'Actualizar Ahora',
        upToDate: 'Su aplicación está actualizada',
        updating: 'Actualizando...',
        platform: 'Plataforma',
        platformValue: 'Aplicación Web Progresiva (PWA)',
        storage: 'Almacenamiento',
        storageValue: 'IndexedDB (Dispositivo Local)',
        appDescription: 'Esta es una aplicación de prueba de concepto offline-first para la observación de higiene de manos. Todos los datos se almacenan localmente en su dispositivo.',
      },
      notFound: {
        code: '404',
        title: 'Página No Encontrada',
        message: 'La página que busca no existe.',
      },
      stars: {
        red: 'Estrella Roja',
        blue: 'Estrella Azul',
        green: 'Estrella Verde',
        yellow: 'Estrella Amarilla',
      },
      filters: {
        toggle: 'Filtros',
        dateRange: 'Rango de Fechas',
        today: 'Hoy',
        last7: 'Últimos 7 días',
        last30: 'Últimos 30 días',
        allDates: 'Todas',
        customRange: 'Personalizado',
        dateFrom: 'Desde',
        dateTo: 'Hasta',
        ward: 'Sala',
        allWards: 'Todas las Salas',
        status: 'Estado',
        allStatuses: 'Todos',
        clearFilters: 'Limpiar Filtros',
        resultsCount: '{{count}} sesión(es)',
      },
      sessionActions: {
        selectedCount: '{{count}} seleccionada(s)',
        exportCSV: 'Exportar CSV',
        print: 'Imprimir Resúmenes',
        clearSelection: 'Limpiar',
        selectAll: 'Seleccionar Todas',
        deselectAll: 'Deseleccionar Todas',
        exportSuccess: 'CSV exportado exitosamente',
        exportError: 'Error al exportar CSV',
      },
      printSummaries: {
        loading: 'Cargando resúmenes de sesión...',
        noSessions: 'No se encontraron sesiones para imprimir',
        backToSessions: 'Volver a Sesiones',
      },
    },
  },
  en: {
    translation: {
      app: {
        name: 'CleanHands',
        tagline: 'Hand Hygiene Observer',
      },
      common: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        save: 'Save',
        delete: 'Delete',
        back: 'Back',
        next: 'Next',
        finish: 'Finish',
        yes: 'Yes',
        no: 'No',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        goHome: 'Go Home',
        offline: 'Offline',
        active: 'Active',
      },
      nav: {
        home: 'Home',
        sessions: 'Sessions',
        settings: 'Settings',
      },
      appBar: {
        home: 'CleanHands',
        newSession: 'New Session',
        observation: 'Observation',
        sessionSummary: 'Session Summary',
        activeSessions: 'Active Sessions',
        settings: 'Settings',
      },
      sideNav: {
        title: 'CleanHands',
        subtitle: 'Hand Hygiene Observer',
      },
      home: {
        title: 'Observation Sessions',
        subtitle: 'View and manage your hand hygiene observation sessions',
        loadingSessions: 'Loading sessions...',
        newSession: 'new session',
        printDate: 'Print date',
        printFilterSummary: 'Showing {{count}} filtered session(s)',
      },
      sessionSetup: {
        title: 'New Observation Session',
        subtitle: 'Enter the details for your hand hygiene observation session',
        facilityName: 'Facility Name',
        facilityPlaceholder: 'e.g., City General Hospital',
        serviceName: 'Service Name',
        servicePlaceholder: 'e.g., Surgery, Pediatrics',
        serviceType: 'Service Type',
        serviceTypePlaceholder: 'e.g., ICU, Emergency, Outpatient',
        wardName: 'Ward Name',
        wardPlaceholder: 'e.g., Ward 3A, ICU-2',
        periodNumber: 'Period Number',
        periodType: 'Period Type',
        observerInitials: 'Observer Initials',
        observerPlaceholder: 'e.g., AB, JD',
        startSession: 'Start Session',
        failedCreate: 'Failed to create session',
        validation: {
          facilityRequired: 'Facility name is required (min 2 characters)',
          serviceRequired: 'Service name is required (min 2 characters)',
          serviceTypeRequired: 'Service type is required',
          wardRequired: 'Ward name is required (min 2 characters)',
          periodMin: 'Period number must be at least 1',
          observerRequired: 'Observer initials required (2-4 characters)',
          observerMax: 'Observer initials must be 2-4 characters',
        },
      },
      periodTypes: {
        baseline: 'Baseline',
        post_intervention: 'Post-Intervention',
        follow_up_1: 'Follow-Up 1',
        follow_up_2: 'Follow-Up 2',
        annual: 'Annual',
      },
      observation: {
        sessionProgress: 'Session Progress',
        complianceRate: 'Compliance Rate',
        totalOpportunities: 'Total Opportunities',
        actionsPerformed: 'Actions Performed',
        missed: 'Missed',
        recordedOpportunities: 'Recorded Opportunities',
        loadingSession: 'Loading session...',
        sessionNotFound: 'Session not found',
        opportunityRecorded: 'Opportunity recorded successfully',
        opportunityDeleted: 'Opportunity deleted',
        failedSave: 'Failed to save opportunity',
        failedDelete: 'Failed to delete opportunity',
      },
      hcwSelector: {
        title: 'Select Healthcare Worker',
        subtitle: 'Tap a colored star to select the category and assign a healthworker',
        searchPlaceholder: 'Search categories...',
      },
      indications: {
        title: 'Select Indication(s)',
        subtitle: 'Select at least one of the 5 moments',
        nextAction: 'Next: Select Action',
        backToHCW: 'Back to Healthcare Worker',
        before_patient: {
          label: 'Before Touching a Patient',
          shortLabel: 'Before Patient',
          description: 'Before touching a patient',
        },
        before_aseptic: {
          label: 'Before Clean/Aseptic Procedure',
          shortLabel: 'Before Aseptic',
          description: 'Before a clean/aseptic procedure',
        },
        after_body_fluid: {
          label: 'After Body Fluid Exposure Risk',
          shortLabel: 'After Body Fluid',
          description: 'After body fluid exposure risk',
        },
        after_patient: {
          label: 'After Touching a Patient',
          shortLabel: 'After Patient',
          description: 'After touching a patient',
        },
        after_surroundings: {
          label: 'After Touching Patient Surroundings',
          shortLabel: 'After Surroundings',
          description: 'After touching patient surroundings',
        },
      },
      actions: {
        title: 'Select Action Taken',
        subtitle: 'What hand hygiene action was performed?',
        handrub: 'Handrub',
        handwash: 'Handwash',
        both: 'Both (Handrub & Handwash)',
        bothShort: 'Both',
        missed: 'Missed',
        backToIndications: 'Back to Indications',
        glovesTitle: 'Were Gloves Worn?',
        glovesSubtitle: 'Since hand hygiene was missed, were gloves worn?',
      },
      recorder: {
        step1: 'Healthcare Worker',
        step2: 'Indications',
        step3: 'Action',
      },
      opportunityList: {
        noOpportunities: 'No opportunities recorded yet',
        tapToRecord: 'Tap the + button to record your first opportunity',
        gloves: 'Gloves',
      },
      sessionTimer: {
        duration: 'Session Duration',
        longSession: 'Long Session',
        lessThan10: '< 10 min',
      },
      sessionList: {
        noSessions: 'No sessions yet',
        createNew: 'Create a new session to get started',
        completed: 'Completed',
        paused: 'Paused',
        inProgress: 'In Progress',
        session: 'Session',
      },
      floatingActions: {
        activeSession: 'Active Session',
        newOpportunity: 'New Opportunity',
        sessionSummary: 'Session Summary',
        endSession: 'End Session',
        sessionActions: 'Session actions',
      },
      exitDialog: {
        title: 'Session in Progress',
        message: 'You have an active observation session. Would you like to save your data and end the session, or continue recording?',
        continueRecording: 'Continue Recording',
        saveAndEnd: 'Save and End Session',
      },
      sessionSummary: {
        title: 'Session Summary',
        facility: 'Facility',
        ward: 'Ward',
        service: 'Service',
        observer: 'Observer',
        date: 'Date',
        duration: 'Duration',
        na: 'N/A',
        overallCompliance: 'Overall Compliance',
        ofOpportunities: '{{performed}} of {{total}} opportunities',
        performed: 'Performed',
        missedLabel: 'Missed',
        glovesWorn: 'Gloves Worn',
        methodBreakdown: 'Method Breakdown',
        handrub: 'Handrub',
        handwash: 'Handwash',
        both: 'Both',
        observationsByCategory: 'Observations by Category',
        categoryHeader: 'Category',
        hwsHeader: 'HWs',
        oppsHeader: 'Opps',
        complianceHeader: 'Compliance',
        complianceByIndication: 'Compliance by Indication (5 Moments)',
        momentHeader: 'Moment',
        countHeader: 'Count',
      },
      sessionReview: {
        recordedOpportunities: 'Recorded Opportunities',
        continueRecording: 'Continue Recording',
        sessionNotes: 'Session Notes',
        notesPlaceholder: 'Add any notes or observations about this session...',
        saveNotes: 'Save Notes',
        exportData: 'Export Data',
        downloadCSV: 'Download CSV',
        allOpportunities: 'All Opportunities',
        returnHome: 'Return Home',
        notesSaved: 'Notes saved successfully',
        failedSaveNotes: 'Failed to save notes',
        csvDownloaded: 'CSV file downloaded successfully',
        failedExport: 'Failed to export CSV',
      },
      activeSessions: {
        title: 'Active Sessions',
        subtitle: 'Select a session to continue recording',
        loadingSessions: 'Loading sessions...',
      },
      settings: {
        title: 'Settings',
        subtitle: 'Configure your application settings',
        language: 'Language',
        languageDescription: 'Select your preferred language',
        spanish: 'Español',
        english: 'English',
        dataManagement: 'Data Management',
        clearDataDescription: 'Clear all local data including sessions, opportunities, and settings. This action cannot be undone.',
        clearAllData: 'Clear All Data',
        clearConfirm: 'Are you sure you want to delete all local data? This action cannot be undone.',
        clearSuccess: 'All data cleared successfully',
        clearError: 'Failed to clear data',
        appInfo: 'Application Info',
        appVersionAndUpdates: 'Version & Updates',
        version: 'Version',
        updateAvailable: 'Update Available',
        updateNow: 'Update Now',
        upToDate: 'Your app is up to date',
        updating: 'Updating...',
        platform: 'Platform',
        platformValue: 'Progressive Web App (PWA)',
        storage: 'Storage',
        storageValue: 'IndexedDB (Local Device)',
        appDescription: 'This is a proof-of-concept offline-first hand hygiene observation application. All data is stored locally on your device.',
      },
      notFound: {
        code: '404',
        title: 'Page Not Found',
        message: "The page you're looking for doesn't exist.",
      },
      stars: {
        red: 'Red Star',
        blue: 'Blue Star',
        green: 'Green Star',
        yellow: 'Yellow Star',
      },
      filters: {
        toggle: 'Filters',
        dateRange: 'Date Range',
        today: 'Today',
        last7: 'Last 7 days',
        last30: 'Last 30 days',
        allDates: 'All',
        customRange: 'Custom',
        dateFrom: 'From',
        dateTo: 'To',
        ward: 'Ward',
        allWards: 'All Wards',
        status: 'Status',
        allStatuses: 'All',
        clearFilters: 'Clear Filters',
        resultsCount: '{{count}} session(s)',
      },
      sessionActions: {
        selectedCount: '{{count}} selected',
        exportCSV: 'Export CSV',
        print: 'Print Summaries',
        clearSelection: 'Clear',
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        exportSuccess: 'CSV exported successfully',
        exportError: 'Failed to export CSV',
      },
      printSummaries: {
        loading: 'Loading session summaries...',
        noSessions: 'No sessions found to print',
        backToSessions: 'Back to Sessions',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    defaultNS: 'translation',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'cleanhands-language',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
